import { decodeToken } from "./decodeToken";

let currentUserJson = localStorage.getItem("currentUser");
export const currentUser = JSON.parse(currentUserJson)